import { Helmet } from "react-helmet";

export const StructuredData = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebSite",
        "@id": "https://skylofiatc.com/#website",
        "url": "https://skylofiatc.com/",
        "name": "Sky Lofi ATC",
        "alternateName": ["Sky Lofi", "Lofi ATC", "Sky Lofi Air Traffic Control"],
        "description": "Stream ambient lofi music mixed with real-time ATC communications from airports worldwide. Perfect for studying, coding, and deep focus.",
        "inLanguage": "en-US",
        "potentialAction": {
          "@type": "SearchAction",
          "target": "https://skylofiatc.com/?s={search_term_string}",
          "query-input": "required name=search_term_string"
        }
      },
      {
        "@type": "MusicRecording",
        "@id": "https://skylofiatc.com/#musicrecording",
        "name": "Sky Lofi ATC Live Stream",
        "description": "24/7 live stream combining lofi hip hop beats with authentic air traffic control radio communications from major international airports",
        "genre": ["Lofi Hip Hop", "Study Music", "Ambient", "Chill Beats"],
        "duration": "PT24H",
        "inLanguage": "en-US",
        "keywords": "lofi, lofi hip hop, ATC radio, air traffic control, study music, focus music, chill beats, ambient music, lofi ATC, study beats, concentration music"
      },
      {
        "@type": "RadioBroadcastService",
        "@id": "https://skylofiatc.com/#broadcast",
        "name": "Sky Lofi ATC Stream",
        "broadcastFrequency": "Online Streaming",
        "description": "Free 24/7 streaming service featuring lofi music and live ATC feeds",
        "genre": ["Lofi Hip Hop", "Aviation Radio", "Study Music"],
        "inLanguage": "en-US"
      },
      {
        "@type": "Organization",
        "@id": "https://skylofiatc.com/#organization",
        "name": "Sky Lofi ATC",
        "url": "https://skylofiatc.com/",
        "logo": "https://skylofiatc.com/favicon.png",
        "sameAs": [],
        "description": "Providing free, ad-free lofi hip hop music streams combined with live air traffic control radio for studying, working, and relaxation"
      },
      {
        "@type": "FAQPage",
        "@id": "https://skylofiatc.com/#faq",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "What is Sky Lofi ATC?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Sky Lofi ATC is a free streaming service that combines relaxing lofi hip hop music with live air traffic control radio communications from airports worldwide. It's perfect for studying, working, coding, or just relaxing."
            }
          },
          {
            "@type": "Question",
            "name": "Is Sky Lofi ATC free to use?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Yes, Sky Lofi ATC is completely free to use with no ads. We offer 24/7 streaming of lofi beats mixed with real ATC radio at no cost."
            }
          },
          {
            "@type": "Question",
            "name": "What airports can I listen to?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Sky Lofi ATC features live ATC feeds from major international airports including Los Angeles (LAX), San Francisco (SFO), Chicago O'Hare (ORD), New York JFK, London Heathrow, Tokyo, Sydney, and many more."
            }
          },
          {
            "@type": "Question",
            "name": "Why combine lofi music with ATC radio?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "The combination of calming lofi beats with ambient ATC chatter creates a unique soundscape that many find perfect for concentration. The rhythmic music provides a steady background while the occasional radio transmissions add an interesting, non-distracting layer of ambient noise."
            }
          },
          {
            "@type": "Question",
            "name": "Can I use Sky Lofi ATC for studying?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Absolutely! Sky Lofi ATC was designed with students and professionals in mind. The lofi beats help maintain focus while the ambient ATC radio provides a unique background that many users find helps them concentrate better than silence or traditional music."
            }
          }
        ]
      }
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};
